import React from 'react';
import { connect } from 'react-redux';

import { promoShape } from '@bibliocommons/bc-prop-types';

import cardShape from 'app/shapes/cardShape';
import { closeModal as closeModalAction, openModal as openModalAction } from 'app/actions/ModalActions';
import PropTypes from 'prop-types';
import DebugCardButton from './DebugCardButton';

const DebugCardButtonContainer = ({ card, closeModal, openModal, promo }) => {
  const modalActions = { closeModal, openModal };
  return <DebugCardButton card={card} modalActions={modalActions} promo={promo} />;
};

DebugCardButtonContainer.propTypes = {
  card: cardShape.isRequired,
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  promo: promoShape.isRequired
};

const mapDispatchToProps = { closeModal: closeModalAction, openModal: openModalAction };

export default connect(null, mapDispatchToProps)(DebugCardButtonContainer);
